import React from 'react';
import PropTypes from 'prop-types';

const DAYS = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];
const LEVELS = 5;

// 0 stays the lightest step; everything else scales against the busiest cell.
const levelFor = (count, max) => (count > 0 && max > 0 ? Math.ceil((count / max) * (LEVELS - 1)) : 0);

const ArrivalHeatmap = ({ arrivals }) => {
  const max = Math.max(0, ...arrivals.cells.flat());

  return (
    <div className="user-activity-card user-activity-heatmap">
      <div className="user-activity-section-header">
        <h3>When records arrive</h3>
        <span className="user-activity-caption">Incoming records in this date range · organization-wide</span>
      </div>
      <div className="user-activity-heatmap-grid">
        <span />
        {DAYS.map((day, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <span key={index} className="user-activity-heatmap-day">{day}</span>
        ))}
        {arrivals.bands.map((band, bandIndex) => (
          <React.Fragment key={band}>
            <span className="user-activity-heatmap-band">{band}</span>
            {arrivals.cells[bandIndex].map((count, dayIndex) => (
              <span
                // eslint-disable-next-line react/no-array-index-key
                key={dayIndex}
                className={`user-activity-heatmap-cell level-${levelFor(count, max)}`}
                title={`${count.toLocaleString()} records`}
              />
            ))}
          </React.Fragment>
        ))}
      </div>
      <div className="user-activity-heatmap-legend">
        <span className="user-activity-caption">Less</span>
        {Array.from({ length: LEVELS }, (_, level) => (
          <span key={level} className={`user-activity-heatmap-cell level-${level}`} />
        ))}
        <span className="user-activity-caption">More</span>
      </div>
    </div>
  );
};

ArrivalHeatmap.propTypes = {
  arrivals: PropTypes.shape({
    bands: PropTypes.arrayOf(PropTypes.string).isRequired,
    cells: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired,
  }).isRequired,
};

export default ArrivalHeatmap;
